export const SHOP_URL = 'https://willygoat.com';
// export const CUSTOMER_SUPPORT_URL = `${SHOP_URL}/pages/contact-us`;
export const API_BASE_URL = 'https://willygoat-customer-portal-386669724669.us-central1.run.app';

export const DEFAULT_DRAFT_ORDER_LIMIT = 10;

export const PO_APPROVED_TAG = 'po-approved';
export const QUOTE_MAX_TOTAL_FOR_CONVERSION = 15000;

/** Payment method label for Government Purchase Orders (must match Shopify option). */

export const EMPTY_IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0100/6072/6369/files/placeholder-new2.png?v=1771262635';

export const SORT_OPTIONS = [
  { value: 'createdAt', label: 'Created', dirDefault: 'desc' },
  { value: 'updatedAt', label: 'Updated', dirDefault: 'desc' },
  { value: 'expirationDate', label: 'Expiration', dirDefault: 'desc' },
  { value: 'name', label: 'Name', dirDefault: 'asc' },
  { value: 'totalPrice', label: 'Total Price', dirDefault: 'desc' },
];

export const FILTER_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'all_quotes', label: 'All Quotes' },
  { value: 'all_orders', label: 'All Orders' },
  { value: 'pending', label: 'Pending' },
  // { value: 'approved', label: 'Approved' },
  { value: 'declined', label: 'Declined' },
  { value: 'expired', label: 'Expired' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'completed', label: 'Completed' },
];

export function customerCanPayByPo(tags) {
  if (tags == null) return false;
  const list = Array.isArray(tags)
    ? tags
    : String(tags).split(',').map((t) => t.trim()).filter(Boolean);
  return list.some((t) => t.toLowerCase() === PO_APPROVED_TAG.toLowerCase());
}

export const RESTRICTED_VENDORS = [
  'Playground Surfacing Partners',
  'Playground Turf Partners',
  'Commercial Installation Partner',
  'Shipping Fees',
  'WillyGoat Toys & Playgrounds'
];

export const NO_UPDATE_QTY_PRODUCT_TYPES = [
  'Miscellaneous Fees',
  'Shade Addon',
  'Shades Addon'
];

export const ONLY_QTY_PRODUCT_TYPES = [
  'Playground Borders',
  'Playground Surfacing'
];

export const NO_UPDATE_CUSTOM_ATTRIBUTES_PRODUCT_TYPES = [
  'Shade Addon',
  'Shades Addon'
];

export const NO_UPDATE_CUSTOM_ATTRIBUTES = [
  '_LeadTime',
  'Lead Time',
  'Ships In',
  '_ShipsIn',
];

export const canUpdateCustomAttributes = (attribute) => {
  if (NO_UPDATE_CUSTOM_ATTRIBUTES.includes(attribute.key)) {
    return false;
  }
  return true;
};

export const canUpdateCustomAttributesType = (item) => {
  if (NO_UPDATE_CUSTOM_ATTRIBUTES_PRODUCT_TYPES.includes(item.productType)) {
    return false;
  }
  return true;
};

export const canEditQuantity = (item) => {
  if (RESTRICTED_VENDORS.includes(item.vendor)) {
    return false;
  }
  if (NO_UPDATE_QTY_PRODUCT_TYPES.includes(item.productType)) {
    return false;
  }
  if (!ONLY_QTY_PRODUCT_TYPES.includes(item.productType)) {
    return false;
  }
  return true;
};

export const canClickImage = (item) => {
  if (RESTRICTED_VENDORS.includes(item.vendor) || NO_UPDATE_QTY_PRODUCT_TYPES.includes(item.productType) ) {
    return false;
  }
  return true;
};




/** Product ID pairs that must be removed together (Material + Labor). Use Shopify product legacyResourceId. */
export const PAIRED_REMOVAL_PRODUCT_IDS = [
  [7437774061665, 7437775044705],   // Turf Playground Surfacing - Labor, Material
  [7251199787105, 7249370153057],   // Pour-In-Place Playground Surfacing - Labor, Material
];

export function getPairedProductId(productId) {
  if (productId == null) return null;
  const id = String(productId).trim();
  for (const [a, b] of PAIRED_REMOVAL_PRODUCT_IDS) {
    if (String(a) === id) return String(b);
    if (String(b) === id) return String(a);
  }
  return null;
}